module.exports = __webpack_public_path__ + "img/icon-download-red.5a502b59.svg";